import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";
import PageWithSideAds from "../components/PageWithSideAds";
import ImageCompressor from "../components/ImageCompressor";

export default function ReductionPage() {
  useSeo({
    title: "Compresser une image – Réduire le poids JPG/WebP | pdf-convert.fr",
    description:
      "Réduisez le poids d’une image (JPG/WebP) en réglant qualité et largeur. Tout se fait dans le navigateur, sans envoi.",
    canonical: "https://pdf-convert.fr/reduction",
  });

  // Breadcrumb
  const breadcrumbJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Accueil",
          item: "https://pdf-convert.fr/home",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Réduction d’image",
          item: "https://pdf-convert.fr/reduction",
        },
      ],
    }),
    []
  );

  useJsonLd("breadcrumb-reduction", breadcrumbJsonLd);

  // FAQ items
  const faqItems = useMemo(
    () => [
      {
        q: "Comment réduire le poids d’une image ?",
        a: "Importez l’image, choisissez le format (JPG/WebP), ajustez la qualité et la largeur max, puis téléchargez l’image optimisée.",
      },
      {
        q: "WebP ou JPG : lequel est le plus léger ?",
        a: "Le WebP est souvent plus léger à qualité similaire. Le JPG reste très compatible sur tous les appareils.",
      },
      {
        q: "Mes images sont-elles envoyées sur un serveur ?",
        a: "Non. La compression se fait directement sur votre appareil, sans upload.",
      },
    ],
    []
  );

  // FAQ JSON-LD
  const faqJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    }),
    [faqItems]
  );

  useJsonLd("faq-jsonld-reduction", faqJsonLd);

  return (
    <PageWithSideAds>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <h1>Réduction d’image</h1>
        <p style={{ textAlign: "center", color: "#666", marginTop: 6 }}>
          Réduis le poids de tes images directement dans ton navigateur.
        </p>

        <ImageCompressor />
      </div>
    </PageWithSideAds>
  );
}
